var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlueFrame(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 340,
    height: 928,
    viewBox: "0 0 340 928",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10741_101709)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 340,
    height: 928,
    fill: "#F9C600"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.511 249.014L213.359 233.784C207.397 229.027 206.408 220.347 211.134 214.385L248.822 166.998C253.579 161.036 252.59 152.355 246.597 147.598L199.21 109.911C193.248 105.154 192.26 96.473 196.986 90.511L212.216 71.3586C216.973 65.3966 225.653 64.4082 231.615 69.1346L279.002 106.822C284.964 111.579 293.645 110.59 298.402 104.598L336.089 57.2106C340.846 51.2486 349.527 50.2598 355.489 54.9862L374.641 70.2157C380.603 74.9729 381.592 83.6534 376.866 89.6154L339.178 137.002C334.421 142.964 335.41 151.645 341.403 156.402L388.79 194.089C394.752 198.846 395.74 207.527 391.014 213.489L375.784 232.641C371.027 238.603 362.347 239.592 356.385 234.865L308.998 197.178C303.036 192.421 294.355 193.41 289.598 199.402L251.911 246.79C247.154 252.752 238.473 253.74 232.511 249.014Z",
    fill: "#E3B505"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.9981 430.002C50.1789 381.954 17.0493 337.183 -30.9983 330.002C-79.046 322.821 -123.817 355.95 -130.998 403.998C-138.179 452.046 -105.05 496.817 -57.0022 503.998C-8.95453 511.179 35.8173 478.05 42.9981 430.002Z",
    stroke: "#E3B505",
    strokeWidth: 16.7454,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.882 757.386L226.73 742.156C220.768 737.399 219.779 728.718 224.505 722.756L262.193 675.369C266.95 669.407 265.961 660.727 259.969 655.97L212.582 618.283C206.62 613.525 205.631 604.845 210.357 598.883L225.587 579.73C230.344 573.768 239.024 572.78 244.986 577.506L292.373 615.193C298.335 619.951 307.016 618.962 311.773 612.969L349.46 565.582C354.218 559.62 362.898 558.632 368.86 563.358L388.013 578.588C393.974 583.345 394.963 592.025 390.237 597.987L352.549 645.374C347.792 651.336 348.781 660.016 354.774 664.774L402.161 702.461C408.123 707.218 409.111 715.899 404.385 721.861L389.155 741.013C384.398 746.975 375.718 747.964 369.756 743.237L322.369 705.55C316.407 700.793 307.726 701.781 302.969 707.774L265.282 755.161C260.525 761.123 251.844 762.112 245.882 757.386Z",
    stroke: "#E3B505",
    strokeWidth: 12.6963,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.9981 950.002C92.1789 901.954 59.0493 857.183 11.0017 850.002C-37.046 842.821 -81.8173 875.95 -88.9981 923.998C-96.1788 972.046 -63.0498 1016.82 -15.0022 1024C33.0455 1031.18 77.8173 998.05 84.9981 950.002Z",
    fill: "#E3B505"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10741_101709"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 340,
    height: 928,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueFrame);
export default __webpack_public_path__ + "static/media/blue_frame.32fc753a1cf601c5c8ac9c28437ecb60.svg";
export { ForwardRef as ReactComponent };